var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanetaazul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.90773 3.27939L5.29024 3.6619L1.59543 7.34857H1.22106V6.9742L4.90773 3.27939ZM6.37263 0.837891C6.27091 0.837891 6.16511 0.878582 6.08779 0.955897L5.34313 1.70056L6.86907 3.2265L7.61373 2.48184C7.77243 2.32314 7.77243 2.05864 7.61373 1.90808L6.66155 0.955897C6.58016 0.874513 6.47843 0.837891 6.37263 0.837891ZM4.90773 2.13596L0.407227 6.63646V8.1624H1.93317L6.43367 3.6619L4.90773 2.13596Z",
    fill: "#273CF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanetaazul);
export default __webpack_public_path__ + "static/media/canetaazul.1308d370afac4158dac3aa6ca8f8ee62.svg";
export { ForwardRef as ReactComponent };